<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M19.4 20H4.6V9h14.8m-3.2-7v2H7.8V2H5.7v2h-1a2 2 0 0 0-2.2 2v14q0 .8.6 1.4t1.5.6h14.8q.8 0 1.5-.6t.6-1.4V6q0-.8-.6-1.4T19.4 4h-1V2m-1.1 11H12v5h5.3z"
    />
  </svg>
</template>
